interface NavbarProps {
  onOpenModal: () => void;
}

export default function Navbar({ onOpenModal }: NavbarProps) {
  return (
    <nav className="site-nav">
      <div className="container nav-inner">
        <a className="wordmark" href="#top" aria-label="AI Token Spend home">
          <span className="wordmark-mark">AI</span><span>token<span className="text-gradient">.fyi</span></span>
        </a>
        <div className="nav-actions">
          <a className="nav-link" href="#leaderboard" onClick={(e) => { e.preventDefault(); document.getElementById('leaderboard')?.scrollIntoView({ behavior: 'smooth' }); }}>Leaderboard</a>
          <button className="btn btn-primary" onClick={onOpenModal}>Submit Spend</button>
        </div>
      </div>
    </nav>
  );
}
